import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ClerkProviderWithRouter from './providers/ClerkProviderWithRouter';
import './index.css';
import { getTraceId, logError } from './lib/logger';
import { installVideoDebugRuntimeCapture } from './lib/videoDebug';
import { captureUiError, initErrorTracking } from './lib/errorTracking';
import { initMetaPixelAds } from './lib/ads/metaPixel';
import { initMixpanelAnalytics } from './lib/mixpanel';
import { registerPwaServiceWorker } from './lib/pwaServiceWorker';

const setAppHeight = () => {
  document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
};

setAppHeight();
window.addEventListener('resize', setAppHeight);

if (import.meta.env.VITE_FORCE_MOTION === 'true') {
  document.documentElement.dataset.forceMotion = 'true';
}

const traceId = getTraceId();
initErrorTracking();
initMetaPixelAds();
initMixpanelAnalytics();
void registerPwaServiceWorker();
installVideoDebugRuntimeCapture(traceId);
window.addEventListener('error', (event) => {
  logError('ui.error', 'Unhandled error', {
    message: event.error?.message || event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
  captureUiError(event.error ?? new Error(event.message), {
    trace_id: traceId,
    source: 'window.error',
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});
window.addEventListener('unhandledrejection', (event) => {
  logError('ui.error', 'Unhandled promise rejection', {
    reason: String(event.reason),
  });
  captureUiError(event.reason, {
    trace_id: traceId,
    source: 'window.unhandledrejection',
  });
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <ClerkProviderWithRouter>
        <App />
      </ClerkProviderWithRouter>
    </BrowserRouter>
  </React.StrictMode>
);
